import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=03b46176&"
import script from "./Goods.vue?vue&type=script&lang=js&"
export * from "./Goods.vue?vue&type=script&lang=js&"
import style0 from "./Goods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports